import {
    USER_GET_FRUI_QPXH_LIST_BEGIN,
    USER_GET_FRUI_QPXH_LIST_SUCCESS,
    USER_GET_FRUI_QPXH_LIST_FAILURE,
    USER_GET_FRUI_QPXH_LIST_DISMISS_ERROR,
  } from './constants';
  
  import request from '../../../utils/request'
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function getFrui_qpxhList(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: USER_GET_FRUI_QPXH_LIST_BEGIN,
      });
     params.size = 10;

     const promise = new Promise((resolve, reject) => {
          request({
            method:'post',
            url:'/api/b/frui_qpxh/list',
            data:params,
          }).then( data => {
              dispatch({
                  type: USER_GET_FRUI_QPXH_LIST_SUCCESS,
                  data: Object.assign({},data,{page:params.page}),
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: USER_GET_FRUI_QPXH_LIST_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissGetFrui_qpxhListError() {
    return {
      type: USER_GET_FRUI_QPXH_LIST_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case USER_GET_FRUI_QPXH_LIST_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          getFrui_qpxhListPending: true,
          getFrui_qpxhListError: null,
        };
  
      case USER_GET_FRUI_QPXH_LIST_SUCCESS:
        // The request is success
  
        const byId = {};
        const items = [];
        action.data.list.forEach(item => {
          items.push(item.id);
          byId[item.id] = item;
        });
        return {
          ...state,
          frui_qpxhById:byId,
          frui_qpxhList:items,
          frui_qpxhPage: action.data.page,
          frui_qpxhSize: action.data.size,
          frui_qpxhTotal: action.data.count,
          getFrui_qpxhListPending: false,
          getFrui_qpxhListError: null,
        };
  
      case USER_GET_FRUI_QPXH_LIST_FAILURE:
        // The request is failed
        return {
          ...state,
          getFrui_qpxhListPending: false,
          getFrui_qpxhListError: action.data.error,
        };
  
      case USER_GET_FRUI_QPXH_LIST_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          getFrui_qpxhListError: null,
        };
  
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/features/user/redux/getFrui_qpxhList.js